export const STATE_IDLE = 0;
export const STATE_VIEWER = 1;
export const STATE_CONNECTED = 2;
export const STATE_WAIT_PRESENTER_CONNECTED = 3;
export const STATE_WAIT_PRESENTER_UNAVAILABLE = 4;
export const STATE_STOPPED = 5;
